<div class="nav-desktop">
    <div>
        <div class="nav-desktop__tabs">
            <div class="nav-desktop__tabs__logo">
                <img [src]="'../../../assets/img/' + headerImage" (click)="clickHeaderImage()"
                     alt="Header logo"
                     [class.pointer-events-none]="isOciUser">
            </div>
            <div class="nav-desktop__tabs__tabs" *ngIf="isAuthorized">
                <nav mat-tab-nav-bar [tabPanel]="tabPanel">
                    <a mat-tab-link
                       *checkViewAsOciUser="false"
                       data-ga-value="nav-orders"
                       (click)="navigateTo(['/orders'])"
                       #tabLink1
                       [active]="tabLink1.active"
                       [myRouterLinkActive]="['/orders/list', '/orders/planning']">
                        {{ 'LABELS.OVERVIEW' | translate }}
                    </a>
                    <ng-container *showWhenRight="'VIEW_INVOICES'">
                        <a mat-tab-link
                           *checkViewAsOciUser="false"
                           [addIntercomDataAttribute]="{key: 'nav-invoices-btn', isMobile: false, isDesktop: true}"
                           data-ga-value="nav-invoices"
                           (click)="navigateTo(['/invoices'])"
                           #tabLink2
                           [active]="tabLink2.active"
                           [myRouterLinkActive]="'/invoices'">
                            {{ 'LABELS.INVOICES' | translate }}
                        </a>
                    </ng-container>
                    <mat-tab-nav-panel #tabPanel></mat-tab-nav-panel>
                </nav>
                <ng-container *showWhenRight="'CREATE_ORDER_REORDER'">
                    <ng-container *ngIf="allowedToOrder$ | async">
                        <button *checkViewAsOciUser="false"
                                aria-label="Create new order"
                                mat-flat-button
                                data-ga-value="nav-new-order"
                                [addIntercomDataAttribute]="{key: 'nav-new-order-btn', isMobile: false, isDesktop: true}"
                                (click)="navigateTo(['/orders/add'])"
                                class="primary" id="open-new-order">
                            <i class="icon icon-plus"></i>
                            {{ 'LABELS.NEW_ORDER' | translate }}
                        </button>
                    </ng-container>
                </ng-container>
            </div>
        </div>
        <div *ngIf="isAuthorized" class="nav-desktop__menus">
            <button mat-button
                    aria-label="Go to company page"
                    data-ga-value="nav-company"
                    [class.pointer-events-none]="isOciUser"
                    [addIntercomDataAttribute]="{key: 'nav-company-btn', isMobile: false, isDesktop: true}"
                    [matMenuTriggerFor]="corporateClientMenu">
                {{ corporateClientName }}
                <i class="icon icon__extra-large icon__right icon-company"></i>
            </button>
            <mat-menu #corporateClientMenu="matMenu">
                <button mat-menu-item
                        aria-label="Go to contact persons"
                        data-ga-value="nav-contact-persons"
                        (click)="navigateTo(['/company/contactpersons'])"
                        [myRouterLinkActive]="'/company/contactpersons'">
                    <i class="icon icon__left icon-people-users"></i>{{ 'LABELS.CONTACT_PERSONS' | translate }}
                </button>
                <button mat-menu-item
                        aria-label="Go to addresses"
                        data-ga-value="nav-addresses"
                        (click)="navigateTo(['/company/addresses'])"
                        [myRouterLinkActive]="'/company/addresses'">
                    <i class="icon icon__left icon-location"></i>{{ 'LABELS.ADDRESSES' | translate }}
                </button>
                <button mat-menu-item
                        aria-label="Go to projects"
                        data-ga-value="nav-projects"
                        (click)="navigateTo(['/company/projects'])"
                        [myRouterLinkActive]="'/company/projects'">
                    <i class="icon icon__left icon-project"></i>{{ 'LABELS.PROJECTS' | translate }}
                </button>
                <button mat-menu-item
                        aria-label="Go to users"
                        data-ga-value="nav-users"
                        (click)="navigateTo(['/company/users'])"
                        [myRouterLinkActive]="'/company/users'">
                    <i class="icon icon__left icon-person"></i>{{ 'LABELS.USERS' | translate }}
                </button>
                <button *showWhenRight="'MANAGE_ROLES_AND_USERS'"
                        mat-menu-item
                        aria-label="Go to roles"
                        data-ga-value="nav-roles"
                        (click)="navigateTo(['/company/roles'])"
                        [myRouterLinkActive]="'/company/roles'">
                    <i class="icon icon__left icon-settings"></i>{{ 'LABELS.ROLES' | translate }}
                </button>
            </mat-menu>
            <button mat-button
                    aria-label="Go to contact page"
                    data-ga-value="nav-contact"
                    [addIntercomDataAttribute]="{key: 'nav-contact-btn', isMobile: false, isDesktop: true}"
                    [matMenuTriggerFor]="helpMenu"><i
                class="icon icon__extra-large icon-support"></i></button>
            <mat-menu #helpMenu="matMenu">
                <button mat-menu-item
                        aria-label="Go to branches"
                        *checkViewAsOciUser="false"
                        data-ga-value="nav-branches"
                        (click)="navigateTo(['/contact/branches'])">
                    <i class="icon icon__left icon-phone"></i>{{ 'LABELS.CONTACT' | translate }}
                </button>
                <button mat-menu-item
                        aria-label="Start guided tour"
                        *checkViewAsOciUser="false"
                        data-ga-value="nav-guided-tour"
                        (click)="getWelcomeGuidedTour()">
                    <i class="icon icon__left icon-tour"></i>{{ 'LABELS.GUIDED_TOUR' | translate }}
                </button>
                <button mat-menu-item
                        aria-label="Report a bug"
                        data-ga-value="nav-usersnap"
                        (click)="openUsersnap()">
                    <i class="icon icon__left icon-bug"></i>{{ 'LABELS.REPORT_A_BUG' | translate }}
                </button>
            </mat-menu>
            <button mat-button
                    aria-label="Open profile menu"
                    [addIntercomDataAttribute]="{key: 'nav-profile-btn', isMobile: false, isDesktop: true}"
                    data-ga-value="nav-profile"
                    [matMenuTriggerFor]="profileMenu"><i
                class="icon icon__extra-large icon-person"></i></button>
            <mat-menu #profileMenu="matMenu" [backdropClass]="'nav-menu__backdrop'" class="nav-menu__full-width">
                <button mat-menu-item
                        aria-label="Go to profile"
                        *checkViewAsOciUser="false"
                        data-ga-value="nav-go-to-profile"
                        [addIntercomDataAttribute]="{key: 'nav-go-to-profile-btn', isMobile: false, isDesktop: true}"
                        (click)="navigateTo(['/profile'])"
                        [myRouterLinkActive]="'/profile'">
                    {{ 'LABELS.MY_PROFILE' | translate }}
                </button>
                <button mat-menu-item
                        aria-label="Open privacy and conditions menu"
                        data-ga-value="nav-privacy-policy"
                        [matMenuTriggerFor]="privacyMenu" (menuOpened)="getPolicyLinks()">
                    {{ 'LABELS.PRIVACY_AND_CONDITIONS' | translate }}
                </button>
                <button mat-menu-item
                        aria-label="Log out"
                        data-ga-value="nav-logout"
                        (click)="logout.emit()">{{ 'LABELS.LOGOUT' | translate }}</button>
            </mat-menu>
        </div>
        <div *ngIf="!isAuthorized" class="nav-desktop__menus">
            <button mat-button
                    aria-label="Open privacy and conditions menu"
                    [matMenuTriggerFor]="privacyMenu" (menuOpened)="getPolicyLinks()">
                {{ 'LABELS.PRIVACY_AND_CONDITIONS' | translate }}
            </button>
        </div>
        <mat-menu #privacyMenu="matMenu">
            <button mat-menu-item class="nav-desktop__privacy-link"
                    aria-label="Open terms and conditions"
                    *ngIf="termsAndConditionsLink">
                <a [href]="termsAndConditionsLink" target="_blank">{{ 'LABELS.TERMS_AND_CONDITIONS' | translate }}</a>
            </button>
            <button mat-menu-item
                    aria-label="Open privacy policy"
                    class="nav-desktop__privacy-link" *ngIf="privacyPolicyLink">
                <a [href]="privacyPolicyLink" target="_blank">{{ 'LABELS.PRIVACY_POLICY' | translate }}</a>
            </button>
            <button mat-menu-item
                    aria-label="Open cookie policy"
                    class="nav-desktop__privacy-link" *ngIf="cookiePolicyLink">
                <a [href]="cookiePolicyLink" target="_blank">{{ 'LABELS.COOKIE_POLICY' | translate }}</a>
            </button>
            <button mat-menu-item
                    aria-label="Open cookie settings"
                    (click)="openCookieSettings()">
                {{ 'LABELS.COOKIE_SETTINGS' | translate }}
            </button>
        </mat-menu>
    </div>
</div>
